import { render, staticRenderFns } from "./PricePanelTypes.vue?vue&type=template&id=6ae5b6e5"
import script from "./PricePanelTypes.vue?vue&type=script&lang=js"
export * from "./PricePanelTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports